import { NextPage } from "next";
import React from "react";
import CustomerDataSettings from "../components/settings/CustomerDataSettings";
import AdminRepairReportExport from "../components/settings/AdminRepairReportExport";
import { useUserContext } from "../contexts/UserContext";

const Settings: NextPage = () => {
  const { isAdmin } = useUserContext();

  return (
    <>
      {isAdmin && <AdminRepairReportExport />}
      <CustomerDataSettings />
    </>
  );
};

export default Settings;
